import React from 'react'
import { getIn, FormikProps } from 'formik'
import { IPackInput, PreviewOptions } from '../../types/pack'
import { getPreviewImages } from '../../services/pack'
import { getNewTmpPreview, createPreviewFieldSetter } from '../../services/file'
import { packPreviewValidate } from './validation'
import {
  H3,
  CustomRadioGroup,
  PreviewPicture,
  PreviewUploadZone,
} from '../../components'
import { StyledRadioGroup } from './styled'

export interface IPackPreviewFormFragment {
  formikProps: FormikProps<IPackInput>
  isFormDisabled?: boolean
  isLightGroup?: boolean
}

export const PackPreviewFormFragment = ({
  formikProps,
  isFormDisabled,
  isLightGroup = false,
}: IPackPreviewFormFragment): JSX.Element | null => {
  const newTmpPreview = getNewTmpPreview(formikProps.values)
  const previewError = getIn(formikProps.errors, 'useGraphicPreview')
  return !!formikProps.values ? (
    <StyledRadioGroup>
      <legend>
        <H3>Preview</H3>
      </legend>
      <div>
        <section>
          <CustomRadioGroup
            name="useGraphicPreview"
            items={[
              {
                label: isLightGroup
                  ? 'Use current preview'
                  : 'Use pack preview',
                value: PreviewOptions.useGraphicPreview,
              },
              {
                label: isLightGroup
                  ? 'Upload a new preview'
                  : 'Upload new pack preview',
                value: PreviewOptions.useUploadedPreview,
              },
            ]}
            disabled={!!isFormDisabled}
            validate={packPreviewValidate(formikProps.values)}
            error={previewError}
          />

          {formikProps.values.useGraphicPreview ===
            PreviewOptions.useUploadedPreview && (
            <PreviewUploadZone
              id={`preview-input-${formikProps.values.id}`}
              setPreviewFieldWrapper={createPreviewFieldSetter(
                formikProps.setFieldValue
              )}
            />
          )}
        </section>
        <picture>
          <PreviewPicture
            width="250px"
            height="250px"
            size="250px"
            src={
              newTmpPreview || getPreviewImages(formikProps.values).thumbnailURI
            }
          />
        </picture>
      </div>
    </StyledRadioGroup>
  ) : null
}
